import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-b6d3bede-8665-4c3f-a992-8f7cd653fdea-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "ec-991d7f94-aadc-45b0-b680-a3b28ab70401-__Layer_2_1_",
      style: {},
      transform: "matrix(-1, 0, 0, 1, 72, 0)"
    }, [
      _createElementVNode("g", { id: "ec-7501b305-6885-41cf-a4b2-9c40b3a2ce63-__Layer_1-2" }, [
        _createElementVNode("path", {
          id: "ec-65b40384-f95b-4f92-a9d9-ca83ba2bc117-__format_italic",
          d: "m54 60h-9.6l-10.7-48h8.3c1.7 0 3-1.3 3-3s-1.3-3-3-3h-24c-1.7 0-3 1.3-3 3s1.3 3 3 3h9.6l10.7 48h-8.3c-1.7 0-3 1.3-3 3s1.3 3 3 3h24c1.7 0 3-1.3 3-3s-1.3-3-3-3z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }